import BackButton from '@luna-protocol/core/src/components/BackButton/BackButton.tsx';
import Banner from '@luna-protocol/core/src/components/Banner/Banner';
import Body from '@luna-protocol/core/src/components/Body/Body';
import { useIntl } from 'react-intl';
import messages from './IDVComplete.messages';

const IDVComplete = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <BackButton path="/identity_verification" inverted />
      <Banner>{formatMessage(messages.title)} </Banner>
      <Body>
        <p>{formatMessage(messages.detail1)}</p>
      </Body>
    </>
  );
};

export default IDVComplete;
